import { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { AuctionPage } from "./pages/AuctionPage";
import { AboutPage } from "./pages/AboutPage";
import { AppHeader } from "./components/AppHeader";
import { WinnerPage } from "./pages/WinnerPage";
import BuildPage from "./pages/BuildPage";
import { VotePage } from "./pages/VotePage";
import { StateService } from "./services/StateService";

import "./App.scss";
import {PLACEHOLDER_MODE} from "./constants";
import PlaceholderPage from "./pages/PlaceholderPage";

interface AppProps {
  state: StateService;
}

const App = observer((props: AppProps) => {
  const [redirected, setRedirected] = useState<boolean>(false);
  const { state } = props;

  useEffect(() => {
    state.rounds.get().forEach((round) => {
      if (round.active && !redirected) {
        if (
          ["voting1", "voting2", "voting3"].includes(round.name) &&
          window.location.pathname !== "/vote"
        ) {
          window.location.href = "vote";
        } else if (
          round.name === "auction" &&
          window.location.pathname !== "/auction"
        ) {
          window.location.href = "auction";
        } else if (
          round.name === "entropy" &&
          window.location.pathname !== "/build"
        ) {
          window.location.href = "build";
        } else if (
          round.name === "done" &&
          window.location.pathname !== "/winners"
        ) {
          window.location.href = "winners";
        }
        setRedirected(true);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.rounds.get().length]);

  return (
    <BrowserRouter>
      <AppHeader state={state} />
      <div className="app-routes">
        <Switch>
          <Route path="/winners">
            <WinnerPage state={state} />
          </Route>
          <Route path="/build">
            <BuildPage state={state} />
          </Route>
          <Route path="/vote">
            <VotePage state={state} />
          </Route>
          <Route path="/auction">
            <AuctionPage state={state} />
          </Route>
          <Route path="/">
            <AboutPage state={state} />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
});

const AppWrapper: React.FC<AppProps> = ({state}) => {
  if (PLACEHOLDER_MODE) {
    return <PlaceholderPage/>;
  }

  return <App state={state} />;
}

export default AppWrapper;
